import { render } from "./PlusIcon.vue?vue&type=template&id=a1b78ab6"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/PlusIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1b78ab6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1b78ab6', __exports__)) {
    api.reload('a1b78ab6', __exports__)
  }
  
  module.hot.accept("./PlusIcon.vue?vue&type=template&id=a1b78ab6", () => {
    api.rerender('a1b78ab6', render)
  })

}


export default __exports__